import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";

import {
  collection,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";

import { useShop } from "../context/ShopContext";

import "./Products.css";


function Products() {

  const {
    name,
    subCategory,
    accessory
  } = useParams();


  const {
    toggleFavorite,
    favorites
  } = useShop();


  const [products, setProducts] = useState([]);

  const [loading, setLoading] = useState(true);


  useEffect(() => {

    const loadProducts = async () => {

      try {

        setLoading(true);


        const snapshot = await getDocs(
          collection(db, "products")
        );


        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));


        const clean = (value) => {

          return String(value || "")
            .trim()
            .toLowerCase();

        };


        const categoryName =
          clean(name);

        const subCategoryName =
          clean(subCategory);

        const accessoryName =
          clean(accessory);


        const filtered = data.filter(product => {

          const productCategory =
            clean(product.category);

          const productSubCategory =
            clean(product.subCategory);

          const productAccessory =
            clean(product.accessory);


          // =========================
          // BABY ACCESSORIES
          // Baby → Accessories → Hats
          // =========================

          if (accessoryName) {

            return (

              productCategory ===
                categoryName &&

              productSubCategory ===
                subCategoryName &&

              productAccessory ===
                accessoryName

            );

          }


          // =========================
          // BABY SUBCATEGORY
          // Baby → Boy / Girl / etc.
          // =========================

          if (subCategoryName) {

            return (

              productCategory ===
                categoryName &&

              productSubCategory ===
                subCategoryName

            );

          }


          // =========================
          // MAIN CATEGORY
          // =========================

          return (

            productCategory ===
              categoryName

          );

        });


        console.log(
          "CATEGORY:",
          name
        );

        console.log(
          "SUBCATEGORY:",
          subCategory
        );

        console.log(
          "ACCESSORY:",
          accessory
        );

        console.log(
          "FILTERED PRODUCTS:",
          filtered
        );


        setProducts(filtered);


      } catch (error) {

        console.error(
          "Error loading products:",
          error
        );

        setProducts([]);

      } finally {

        setLoading(false);

      }

    };


    loadProducts();

  }, [
    name,
    subCategory,
    accessory
  ]);


  const pageTitle =
    accessory ||
    subCategory ||
    name;


  return (

    <div className="products-page">


      <h1>
        {pageTitle}
      </h1>


      {loading && (

        <div className="products-loading">
          Loading...
        </div>

      )}


      {!loading &&
        products.length === 0 && (

          <h2 className="empty-products">
            No Products Found 🤍
          </h2>

        )}


      {!loading &&
        products.length > 0 && (

          <div className="products-container">

            {products.map(product => (

              <div
                className="product-card"
                key={product.id}
              >


                <button
                  className="heart-btn"
                  onClick={() =>
                    toggleFavorite(product)
                  }
                >

                  {favorites.some(
                    item =>
                      item.id === product.id
                  )
                    ? "❤️"
                    : "🤍"
                  }

                </button>


                <Link
                  to={`/product/${product.id}`}
                  className="product-link"
                >

                  <img
                    src={
                      product.images?.[0] ||
                      "/no-image.png"
                    }
                    alt={product.name}
                  />


                  <h2>
                    {product.name}
                  </h2>

                </Link>


                <p>
                  ${product.price}
                </p>


              </div>

            ))}

          </div>

        )}

    </div>

  );

}


export default Products;